import Head from "expo-router/head";
import { Theme, View } from "tamagui";

import { Redirect, ScrollView } from "@/components";
import { brandName } from "@/config/brand";
import CuraiConvoWrapper from "@/conversation/CuraiConvoWrapper";
import NoriConvoWrapper from "@/conversation/NoriConvoWrapper";
import {
  useCurrentConversationId,
  useCurrentConversationType,
  useCurrentNotificationId,
  useGroupHeadConversationId,
} from "@/hooks/conversation";
import { useInfiniteMessages } from "@/hooks/useInfiniteMessages";

export default function ConversationPage() {
  const id = useCurrentConversationId();
  const notificationId = useCurrentNotificationId();
  const { data: conversationType } = useCurrentConversationType();
  const { data: messagesData } = useInfiniteMessages(id);
  const conversationTitle = messagesData?.pages[0]?.conversation?.title;
  const isClinic = conversationType === "curai";
  const groupHeadId = useGroupHeadConversationId(id);

  if (!id) {
    return (
      <Redirect
        href="/"
        reason="No conversation ID"
        context={{
          conversationType,
        }}
      />
    );
  }

  if (groupHeadId) {
    // notificationId is not a propagated param, so it is carried over by hand — dropping it
    // would lose the notification this conversation was opened to read.
    return (
      <Redirect
        href={`/conversation/${groupHeadId}${
          notificationId ? `?notificationId=${notificationId}` : ""
        }`}
        reason="URL names an older conversation in the group"
        context={{ conversationId: id, groupHeadId }}
      />
    );
  }

  return (
    <>
      <Head>
        <title>{`${conversationTitle ?? "Conversation"} — ${brandName}`}</title>
      </Head>
      <Theme name={isClinic ? "clinic" : undefined}>
        <ScrollView
          contentContainerStyle={{ height: "100%" }}
          keyboardShouldPersistTaps="handled"
          showsVerticalScrollIndicator={false}
          backgroundColor="$backgroundGround"
        >
          <View
            backgroundColor="$backgroundFill"
            height="100%"
            width="100%"
            alignItems="stretch"
            justifyContent="center"
            flex={1}
            borderRadius="$screenBorderRadius"
            $lg={{ paddingBottom: "$200" }}
          >
            {isClinic ? (
              <CuraiConvoWrapper conversationId={id} />
            ) : (
              <NoriConvoWrapper conversationId={id} />
            )}
          </View>
        </ScrollView>
      </Theme>
    </>
  );
}
